import React from "react";
import Doctor from "../Assets/doctor-book-appointment.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "../Styles/BookAppointment.css";

function BookAppointment() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isRTL = i18n.language === 'he'; // Check if the current language is Hebrew

  const handleBookAppointmentClick = () => {
    navigate("/appointment");
  };

  return (
    <div className={`ba-section ${isRTL ? 'rtl' : ''}`}>
      <div className="ba-image-content">
        <img src={Doctor} alt={t("doctorAlt")} className="ba-image1" />
      </div>

      <div className="ba-text-content">
        <h3 className="ba-title">
          <span>{t("whyChooseDrShahada")}</span>
        </h3>
        <p className="ba-description">
          {t("baDescription")}
        </p>

        <p className="ba-checks ba-check-first">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> {t("specializedInPTSD")}
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> {t("compassionateCare")}
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> {t("evidenceBasedPlans")}
        </p>
        <p className="ba-checks ba-check-last">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> {t("flexibleScheduling")}
        </p>

        <button
          className="text-appointment-btn"
          type="button"
          onClick={handleBookAppointmentClick}
        >
          <FontAwesomeIcon icon={faCalendarCheck} /> {t("bookAppointment")}
        </button>
      </div>
    </div>
  );
}

export default BookAppointment;
